/* ============================================================
   Quick-Add  ·  Kollektionsseite Bidetlity
   - [data-qa-open][data-handle]  -> Sheet/Modal mit Optionen
   - [data-qa-direct][data-vid]   -> direkt in den Warenkorb (Zubehör / 1 Variante)
   Cart: /cart/add.js -> Section-Refresh (cart-helper) -> <sidebar-drawer id="site-cart">.show()
   ============================================================ */
(function () {
  'use strict';
  if (window.__blQuickAddInit) return; window.__blQuickAddInit = 1; // Doppel-Init verhindern (Kollektion + Drawer)
  var QA_EN = /^en/i.test(document.documentElement.lang || '') || /^\/en(\/|$)/.test(location.pathname); // i18n (wie BL_EN in bl-cart.js) — nur Anzeige, nie Matching-Keys

  // Farbname -> Hex (Bidetlity-CI, synchron mit bl-bundle-configurator BL_COLOR; aus echten Swatch-Bildern gesampelt).
  // Unbekannte Farben fallen auf das Varianten-Foto zurück.
  var COLOR = {
    'proud purple': '#b58fff', 'purple edition': '#b58fff',
    'precious peach': '#ff723e', 'peach edition': '#ff723e',
    'minty mint': '#cdf0d0', 'mint edition': '#cdf0d0',
    'royal ruby': '#694f5b', 'dark red edition': '#a5300a',
    'bold black': '#16181a', 'classic black': '#16181a', 'black': '#16181a',
    'gentle grey': '#e0e4d7', 'clean white': '#f1f3ee', 'soft sand': '#e1c8b4',
    // Wandhaken-Farben (fehlten -> alle grau)
    'weiß': '#ffffff', 'weiss': '#ffffff', 'white': '#ffffff',
    'schwarz': '#16181a', 'grün': '#7c9686', 'gruen': '#7c9686', 'korall': '#ff723e', 'orange': '#ff723e',
    // Englische Wertnamen (auf /en liefert Shopify die uebersetzten Optionswerte) — sonst waeren die Kreise grau
    'green': '#7c9686', 'coral': '#ff723e'
  };

  // Options-NAMEN, die Shopify nicht uebersetzt (Matching-Keys, duerfen im Shop nicht uebersetzt werden).
  // Nur Anzeige im Quick-Add — gematcht wird weiterhin mit dem deutschen Original. 17.09.2026
  var QA_NAME = {
    'menge': 'Quantity',
    'größe': 'Size',
    'größe set': 'Set size',
    'set-größe': 'Set size',
    'größe wählen': 'Size',
    'farbe wandhaken': 'Wall hook color',
    'dusch-vibe': 'Shower vibe',
    'wähle den wert deines gutscheins': 'Choose your gift card amount',
    'spare verpackung': 'Packaging',
    'form': 'Shape',
    'länge': 'Length',
    'länge wählen': 'Length'
  };
  function qaName(n) { return (QA_EN && QA_NAME[String(n || '').toLowerCase().trim()]) || n; }
  // Options-WERTE, die auch auf /en deutsch bleiben (Matching-Keys, z. B. data-form="D-Form/O-Form") — nur Anzeige
  var QA_VAL = { 'D-Form': 'D-shape', 'O-Form': 'O-shape' };
  function qaVal(v) { return (QA_EN && QA_VAL[v]) || v; }

  // Produkt-JSON immer in der Sprache der Seite laden (/en/products/...js liefert den
  // uebersetzten Titel und die uebersetzten Optionswerte; die Varianten-IDs sind identisch).
  var LOC_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function productUrl(handle) { return LOC_ROOT.replace(/\/$/, '') + '/products/' + handle + '.js'; }

  // Kurz-Info je Variante (Text von der Produktseite) — erklärt im Quick-Add "was ist was"
  var VARIANT_INFO = {
    'Turbo Tornado': QA_EN ? 'Strong & precise – maximum power for a thorough clean.' : 'Stark & präzise – maximale Strahlkraft für gründliche Reinigung.',
    'Streamy Spa': QA_EN ? 'Gentle & effective – ideal for sensitive skin (standard on the butt shower).' : 'Sanft & effektiv – ideal für empfindliche Haut (Standard bei der Po-Dusche).',
    'Steamy Spa': QA_EN ? 'Gentle & effective – ideal for sensitive skin (standard on the butt shower).' : 'Sanft & effektiv – ideal für empfindliche Haut (Standard bei der Po-Dusche).'
  };

  // Inline-Erklärung "Spare Verpackung" (Quelle: product.po-dusche moretext) — kein zweites Popup
  var PACK_NOTE = QA_EN
    ? '<b>Unpacked:</b> no extra product box — you save resources and emissions. '
    + 'Your Bidetlity comes with a hygiene seal in a linen bag inside the shipping box.<br>'
    + '<b>Packed:</b> in the original product box (ideal as a gift).'
    : '<b>Unverpackt:</b> ohne extra Produktkarton — du sparst Ressourcen und Emissionen. '
    + 'Dein Bidetlity kommt mit Hygienesiegel im Leinensäckchen im Versandkarton.<br>'
    + '<b>Verpackt:</b> mit Original-Produktkarton (ideal zum Verschenken).';

  var routes = (window.KROWN && KROWN.settings && KROWN.settings.routes) || {};
  var ADD_URL = (routes.cart_add_url || '/cart/add');
  var cache = {};
  var overlay, panel;

    /* 23.09.2026: Preis kommt aus der Shopify-Währungsformatierung des Shops
     (Einstellungen > Allgemein > Währungsformatierung). Vorher war hier '€' fest
     vorangestellt — nach der Umstellung auf '19,90 €' passte das nicht mehr zum Rest
     des Shops. Fällt auf deutsche Schreibweise zurück, falls das Theme-Objekt fehlt. */
function blMoney(cents) {
    cents = Math.max(0, Math.round(cents));
    try {
      var f = window.KROWN && KROWN.settings && KROWN.settings.shop_money_format;
      if (f && window.KROWN.helpers && KROWN.helpers.formatMoney) {
        return KROWN.helpers.formatMoney(cents, f).replace(/<[^>]*>/g, '');
      }
    } catch (e) {}
    var ev = Math.floor(cents / 100), c = cents % 100;
    return ev.toLocaleString('de-DE') + ',' + (c < 10 ? '0' : '') + c + ' \u20ac';
  }
  function money(cents) { return blMoney(cents); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sized(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function isDesktop() { return window.matchMedia('(min-width: 768px)').matches; }
  function optionValues(product, i) {
    var key = 'option' + (i + 1), out = [];
    product.variants.forEach(function (v) { if (out.indexOf(v[key]) === -1) out.push(v[key]); });
    return out;
  }
  function isColorOption(name) { return /farbe|colou?r|farve/i.test(name || ''); }
  function valueAvailable(product, i, val, state) {
    // verfügbar, wenn irgendeine Variante mit diesem Wert (bei sonst gewählten Optionen) lieferbar ist
    return product.variants.some(function (v) {
      if (v['option' + (i + 1)] !== val || !v.available) return false;
      for (var j = 0; j < state.length; j++) { if (j !== i && state[j] != null && v['option' + (j + 1)] !== state[j]) return false; }
      return true;
    });
  }
  function resolveVariant(product, state) {
    return product.variants.find(function (v) {
      for (var i = 0; i < state.length; i++) { if (v['option' + (i + 1)] !== state[i]) return false; }
      return true;
    });
  }

  // ---------- New Standard: Form + Kaltwasserschlauch-Länge (16.09.2026) ----------
  // Die 200/300-cm-Schläuche fehlen -> 200/300/400 cm = Hilfs-Bundles (100 cm Schlauch + Schlauchverlängerung ½″ + Verbindungsstück).
  // Gleiche Zuordnung wie bl-ns-vmap in sections/bl-newstandard.liquid. Rückbau, sobald die Schläuche da sind.
  var NS_HANDLE = 'bidetlity-new-standard-bidet-aufsatz-ohne-strom';
  var NS_LEN = [
    { len: '100 cm', handle: null },
    { len: '200 cm', handle: 'bidetlity-new-standard-200cm' },
    { len: '300 cm', handle: 'bidetlity-new-standard-300cm' }
  ];
  function isEn() { return /^en/i.test(document.documentElement.lang || ''); }
  function nsNote(len) {
    var ext = { '200 cm': '100', '300 cm': '200', '400 cm': '300' }[len];
    return isEn()
      ? 'Good to know: ' + len + ' comes as a 100 cm hose + ' + ext + ' cm extension. The connector is included free.'
      : 'Zur Info: ' + len + ' bekommst du als 100 cm Schlauch + ' + ext + ' cm Verlängerung. Das Verbindungsstück liegt gratis bei.';
  }
  // Baut aus Hauptbundle + Hilfs-Bundles ein Produkt mit den Optionen Form × Länge
  function buildNS(p) {
    // 02.10.2026: Hat das Hauptbundle schon Längen-Varianten (Form × Länge), direkt verwenden – nur Optionsnamen lesbar machen.
    if (p && p.options && p.options.length > 1) {
      return Promise.resolve(Object.assign({}, p, {
        options: [p.options[0], { name: isEn() ? 'Cold-water hose (Length)' : 'Kaltwasserschlauch (Länge)' }].concat(p.options.slice(2))
      }));
    }
    return Promise.all(NS_LEN.map(function (l) {
      return l.handle ? fetch(productUrl(l.handle)).then(function (r) { if (!r.ok) throw new Error('ns bundle'); return r.json(); }) : Promise.resolve(p);
    })).then(function (prods) {
      var variants = [];
      NS_LEN.forEach(function (l, k) {
        prods[k].variants.forEach(function (v) {
          variants.push(Object.assign({}, v, { option2: l.len, option3: null, title: v.option1 + ' / ' + l.len, featured_image: null }));
        });
      });
      return Object.assign({}, p, {
        options: [p.options[0], { name: isEn() ? 'Cold-water hose (Length)' : 'Kaltwasserschlauch (Länge)' }],
        variants: variants,
        __vinfo: { '200 cm': nsNote('200 cm'), '300 cm': nsNote('300 cm') }
        // Vorauswahl = erste lieferbare Variante = 100 cm (Lucius 16.09.2026)
      });
    });
  }

  // ---------- Overlay einmalig ----------
  function ensureOverlay() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'qa-overlay';
    overlay.innerHTML = '<div class="qa-backdrop"></div>';
    document.body.appendChild(overlay);
    overlay.querySelector('.qa-backdrop').addEventListener('click', close);
    // 30.10.2026: Capture auf window -> bei offenem Sheet schließt Escape nur das Sheet, nicht auch den Warenkorb-Drawer (theme.js)
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) { close(); e.stopPropagation(); } }, true);
  }
  function close() {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    if (_upsellTag && window.blUpsellTrack) { var _tc = _upsellTag.split(':'); window.blUpsellTrack('bl_qa_close', _tc[0], _tc[1] || '', null); }   // ohne Kauf geschlossen
    _upsellTag = null; _upsellDelta = null;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var p = panel; panel = null;
    setTimeout(function () { if (p) p.remove(); }, 340);
  }

  // ---------- Options-Label lesbar machen (Bundles: Komponente statt nacktes "Farbe") ----------
  // "Po-Dusche (Farbe)" -> Komponente "Po-Dusche"; "Wandhaken (Farbe Wandhaken)" -> "Wandhaken".
  function qaPrefix(name){ var m = String(name || '').match(/^(.*?)\s*\(/); return m ? m[1].trim() : ''; }
  function qaAttr(name){
    var m = String(name || '').match(/\(([^)]*)\)/);
    var a = m ? m[1].trim() : String(name || '').trim();
    if (/verpack/i.test(a)) return QA_EN ? 'Packaging' : 'Verpackung';
    if (/farbe|color/i.test(a)) return QA_EN ? 'Color' : 'Farbe';
    return qaName(a);
  }
  // ---------- Blöcke rendern ----------
  function blocksHTML(product, state, prefilled) {
    var html = '';
    product.options.forEach(function (opt, i) {
      if (prefilled && prefilled[i]) return;      // schon aus dem Korb vorbefüllt -> nicht nochmal fragen
      var name = opt.name || opt;                 // product.js: string oder {name,values}
      var vals = optionValues(product, i);
      if (vals.length <= 1 && vals[0] === 'Default Title') return; // keine echte Option
      if (/menge|quantity/i.test(name)) {                  // Mengen-Staffel (Waschstück): Pro-Stück-Zeilen wie PDP
        html += '<div class="qa-block qa-qtyblock" data-oi="' + i + '"><div class="qa-label">' + (QA_EN ? 'Quantity' : 'Menge') + '</div>'
          + '<div class="qa-qtypick" role="radiogroup" aria-label="' + esc(qaName(name)) + '">';
        vals.forEach(function (val) {
          var variant = product.variants.find(function (v) { return v['option' + (i + 1)] === val; });
          var av = valueAvailable(product, i, val, state);
          var qn = (String(val).match(/(\d+)/) || [])[1]; qn = qn ? parseInt(qn, 10) : 1; if (qn < 1) qn = 1;
          var pp = variant ? Math.round(variant.price / qn) : 0;
          var disc = (variant && variant.compare_at_price > variant.price) ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
          var save = (variant && variant.compare_at_price > variant.price) ? (variant.compare_at_price - variant.price) : 0;
          html += '<button type="button" class="qa-qrow' + (state[i] === val ? ' sel' : '') + '" data-oi="' + i + '" data-val="' + esc(val) + '"' + (av ? '' : ' disabled') + '>'
            + '<span class="qa-qname">' + esc(val) + '</span>'
            + '<span class="qa-qcol"><span class="qa-qright"><span class="qa-qpp"><b>' + money(pp) + '</b> ' + (QA_EN ? '/ each' : '/ Stück') + '</span>'
            + (disc > 0 ? '<span class="qa-qdisc">−' + disc + '%</span>' : '') + '</span>'
            + '<span class="qa-qsave">' + (save > 0 ? ((QA_EN ? 'Save ' : 'Spare ') + money(save)) : '') + '</span></span></button>';
        });
        html += '</div></div>';
        return;
      }
      if (isColorOption(name)) {
        html += '<div class="qa-block" data-oi="' + i + '">'
          + '<div class="qa-label">' + esc(qaPrefix(name) || (QA_EN ? 'Color' : 'Farbe')) + ': <span class="qa-cname">' + esc(state[i]) + '</span></div>'
          + '<div class="qa-colors" role="radiogroup" aria-label="' + esc(qaName(name)) + '">';
        vals.forEach(function (val) {
          var hex = COLOR[String(val).toLowerCase().trim()];
          var av = valueAvailable(product, i, val, state);
          var variant = product.variants.find(function (v) { return v['option' + (i + 1)] === val; });
          var style = hex ? 'background:' + hex : (variant && variant.featured_image ? 'background-image:url(' + sized(variant.featured_image.src, 80) + ')' : 'background:#d9dccf');
          html += '<button type="button" class="qa-sw' + (state[i] === val ? ' sel' : '') + '" role="radio"'
            + ' aria-checked="' + (state[i] === val) + '" data-oi="' + i + '" data-val="' + esc(val) + '"'
            + (av ? '' : ' disabled') + ' aria-label="' + esc(val) + '" title="' + esc(val) + '" style="' + style + '"></button>';
        });
        html += '</div></div>';
      } else {
        var isPack = /verpackung/i.test(name);
        var info = isPack ? '<button type="button" class="qa-info" data-note>' + (QA_EN ? 'What\'s the difference?' : 'Was ist der Unterschied?') + '</button>' : '';
        var nlbl = qaPrefix(name) ? (qaPrefix(name) + ' · ' + qaAttr(name)) : qaAttr(name);
        html += '<div class="qa-block" data-oi="' + i + '">'
          + '<div class="qa-labelrow"><span class="qa-label">' + esc(nlbl) + '</span>' + info + '</div>'
          + '<div class="qa-pack" role="radiogroup" aria-label="' + esc(qaName(name)) + '">';
        vals.forEach(function (val) {
          var av = valueAvailable(product, i, val, state);
          html += '<button type="button" class="qa-opt' + (state[i] === val ? ' active' : '') + '"'
            + ' data-oi="' + i + '" data-val="' + esc(val) + '"' + (av ? '' : ' disabled') + '>' + esc(qaVal(val)) + '</button>';
        });
        var vinfo = '';
        var infoMap = product.__vinfo || VARIANT_INFO;
        for (var vv = 0; vv < vals.length; vv++) { if (infoMap[vals[vv]]) { vinfo = '<div class="qa-varinfo" data-oi="' + i + '">' + esc(infoMap[state[i]] || '') + '</div>'; break; } }
        html += '</div>' + vinfo + (isPack ? '<div class="qa-note" hidden>' + PACK_NOTE + '</div>' : '') + '</div>';
      }
    });
    return html;
  }

  function headHTML(product, raters) {
    var rc = raters ? ' <span>(' + esc(raters) + ')</span>' : '';
    return '<div class="qa-name">' + esc(product.title) + '</div>'
      + (raters ? '<div class="qa-rev"><span class="qa-stars">★★★★★</span>' + rc + '</div>' : '')   // 30.10.2026: ohne Bewertungszahl keine Sterne
      + '<div class="qa-price"></div>';
  }

  function render(product, raters) {
    ensureOverlay();
    if (panel) panel.remove();
    var layout = isDesktop() ? 'modal' : 'sheet';
    // Default = erste lieferbare Variante
    var base = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    var state = product.options.map(function (o, i) { return base['option' + (i + 1)]; });
    if (product.__noPreselect) product.__noPreselect.forEach(function (i) { state[i] = null; }); // NS: Länge muss aktiv gewählt werden
    // 30.10.2026 (Lucius): Zubehör aus dem Warenkorb-Upsell -> Farbe aktiv wählen lassen, nichts vorauswählen
    if (_upsellTag) product.options.forEach(function (o, i) { if (isColorOption(o.name || o)) state[i] = null; });   // gilt auch für Set-Vervollständigung (Korb-Farben werden weiter vorbefüllt)
    // Vorbefüllung aus dem Korb: Optionen, deren Komponente schon im Korb liegt (z.B. 1. Toilettenhocker),
    // mit der Korb-Farbe füllen UND im Sheet ausblenden -> nur die noch fehlende Einheit wird gefragt.
    var prefilled = {};
    try {
      var cc = window.__blCartCache;
      if (cc && cc.items) {
        var byTitle = {};
        cc.items.forEach(function (it) {
          var _tk = String(it.product_title || '').toLowerCase().trim(), _tv = (it.options_with_values || []).map(function (o) { return String(o.value || '').toLowerCase().trim(); });
          byTitle[_tk] = _tv;
          var _short = _tk.replace(/^(mobile|portable)\s+/, ''); if (_short !== _tk && !byTitle[_short]) byTitle[_short] = _tv;   // 30.10.2026: „Mobile Po-Dusche“ -> Set-Option „Po-Dusche (Farbe)“
        });
        product.options.forEach(function (opt, i) {
          var nm = opt.name || opt, mm = String(nm).match(/^(.*?)\s*\(/);
          var cv = byTitle[(mm ? mm[1] : String(nm)).toLowerCase().trim()];
          if (cv) { var ov = optionValues(product, i);
            for (var vi = 0; vi < ov.length; vi++) { if (cv.indexOf(String(ov[vi]).toLowerCase().trim()) >= 0) { state[i] = ov[vi]; prefilled[i] = true; break; } }
          }
        });
      }
    } catch (e) {}

    panel = document.createElement('div');
    panel.className = 'qa qa--' + layout;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', QA_EN ? 'Quick add' : 'Schnell hinzufügen');

    var media = '<div class="qa-media"><img alt="' + esc(product.title) + '"></div>';
    var cta = '<button type="button" class="qa-cta"></button>';
    var details = _upsellTag ? '' : '<a class="qa-details" href="' + esc(product.url) + '">' + (QA_EN ? 'View product' : 'Zur Produktseite') + '</a>';   // Upsell: nicht weg vom Warenkorb
    var closeBtn = '<button type="button" class="qa-close" aria-label="' + (QA_EN ? 'Close' : 'Schließen') + '">✕</button>';

    if (layout === 'sheet') {
      panel.innerHTML = closeBtn + '<div class="qa-handle"></div>'
        + '<div class="qa-head">' + media + '<div class="qa-htext">' + headHTML(product, raters) + '</div></div>'
        + blocksHTML(product, state, prefilled) + cta + details;
    } else {
      panel.innerHTML = closeBtn + media
        + '<div class="qa-right"><div class="qa-head">' + headHTML(product, raters) + '</div>'
        + blocksHTML(product, state, prefilled) + cta + details + '</div>';
    }

    overlay.appendChild(panel);
    wire(product, state);
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    update(product, state);
  }

  function wire(product, state) {
    panel.querySelector('.qa-close').addEventListener('click', close);
    // Farb-Swatches
    panel.querySelectorAll('.qa-sw').forEach(function (sw) {
      sw.addEventListener('click', function () {
        if (sw.hasAttribute('disabled')) return;
        var i = +sw.dataset.oi; state[i] = sw.dataset.val;
        var group = sw.parentNode;
        group.querySelectorAll('.qa-sw').forEach(function (s) { s.classList.remove('sel'); s.setAttribute('aria-checked', 'false'); });
        sw.classList.add('sel'); sw.setAttribute('aria-checked', 'true');
        var cname = panel.querySelector('.qa-block[data-oi="' + i + '"] .qa-cname'); if (cname) cname.textContent = sw.dataset.val;
        update(product, state);
      });
    });
    // Pills
    panel.querySelectorAll('.qa-opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        if (opt.hasAttribute('disabled')) return;
        var i = +opt.dataset.oi; state[i] = opt.dataset.val;
        opt.parentNode.querySelectorAll('.qa-opt').forEach(function (o) { o.classList.remove('active'); });
        opt.classList.add('active');
        var vinfo = panel.querySelector('.qa-varinfo[data-oi="' + i + '"]');
        if (vinfo && product.__vinfo) vinfo.textContent = product.__vinfo[opt.dataset.val] || '';
        else if (vinfo && VARIANT_INFO[opt.dataset.val]) vinfo.textContent = VARIANT_INFO[opt.dataset.val];
        update(product, state);
      });
    });
    // Mengen-Zeilen (Waschstück)
    panel.querySelectorAll('.qa-qrow').forEach(function (row) {
      row.addEventListener('click', function () {
        if (row.hasAttribute('disabled')) return;
        var i = +row.dataset.oi; state[i] = row.dataset.val;
        row.parentNode.querySelectorAll('.qa-qrow').forEach(function (r) { r.classList.remove('sel'); });
        row.classList.add('sel');
        update(product, state);
      });
    });
    // Inline-Erklärung auf-/zuklappen (kein zweites Popup)
    panel.querySelectorAll('.qa-info[data-note]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var note = btn.closest('.qa-block').querySelector('.qa-note');
        if (!note) return;
        var wasHidden = note.hasAttribute('hidden');
        if (wasHidden) note.removeAttribute('hidden'); else note.setAttribute('hidden', '');
        btn.textContent = wasHidden ? (QA_EN ? 'Close' : 'Schließen') : (QA_EN ? 'What\'s the difference?' : 'Was ist der Unterschied?');
      });
    });
    // CTA
    panel.querySelector('.qa-cta').addEventListener('click', function () {
      var v = resolveVariant(product, state);
      if (!v || !v.available) return;
      var btn = this; btn.disabled = true; ctaText(btn, QA_EN ? 'Adding …' : 'Wird hinzugefügt …');
      var tag = _upsellTag;
      if (tag && window.blAttrHold) window.blAttrHold();
      addToCart(v.id, tag).then(function () {
        _upsellTag = null;
        if (tag && window.blUpsellTrack) { var _tp = tag.split(':'); window.blUpsellTrack('bl_upsell_add', _tp[0], _tp[1] || '', null); } // 30.10.2026: erst nach erfolgreichem Add zählen
        var rk = _removeKeys; _removeKeys = null;
        if (rk) { // Set-Vervollständigung: je Komponente NUR EIN Stück ins Set übernehmen -> Menge um 1 reduzieren (Rest bleibt im Korb)
          var keys = rk.split(',').filter(Boolean);
          return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
            var qty = {}; (cart.items || []).forEach(function (it) { qty[it.key] = it.quantity || 1; });
            var updates = {}; keys.forEach(function (k) { updates[k] = Math.max(0, (qty[k] || 1) - 1); });
            return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
          }).then(refreshCart).then(function () { close(); openDrawer(); });
        }
        close(); openDrawer();
      })
        .catch(function () { btn.disabled = false; update(product, state); });
    });
  }

  function update(product, state) {
    var v = resolveVariant(product, state);
    var img = panel.querySelector('.qa-media img');
    var src = (v && v.featured_image && v.featured_image.src) || product.featured_image || (product.images && product.images[0]);
    if (img && src) img.src = sized(src, isDesktop() ? 640 : 320);
    var priceEl = panel.querySelector('.qa-price');
    var cta = panel.querySelector('.qa-cta');
    if (v) {
      priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
      if (v.available && _upsellDelta != null && _upsellTag && _upsellTag.indexOf('set:') === 0) {
        // Aufpreis = gewählte Set-Variante minus der Korb-Teile, die ins Set wandern (je 1 Stück, Preis aus dem Korb)
        var gone = 0, keys = (_removeKeys || '').split(',').filter(Boolean), cc = window.__blCartCache;
        if (keys.length && cc && cc.items) cc.items.forEach(function (it) { if (keys.indexOf(it.key) > -1) gone += (it.final_price != null ? it.final_price : it.price) || 0; });
        var plus = keys.length && cc ? v.price - gone : _upsellDelta;
        cta.disabled = false; ctaText(cta, (QA_EN ? 'Get the set · +' : 'Set sichern · +') + money(Math.max(0, plus)));
      } else if (v.available) { cta.disabled = false; ctaText(cta, (QA_EN ? 'Add to cart · ' : 'In den Warenkorb · ') + money(v.price)); }
      else { cta.disabled = true; ctaText(cta, QA_EN ? 'Sold out' : 'Ausverkauft'); }
    } else if (state.indexOf(null) > -1) {     // NS: Länge noch nicht gewählt
      priceEl.innerHTML = money(product.variants[0].price);
      cta.disabled = true; ctaText(cta, product.__noPreselect ? (isEn() ? 'Choose a hose length first' : 'Erst Schlauchlänge wählen') : (QA_EN ? 'Pick a color first' : 'Erst Farbe wählen'));
    } else { cta.disabled = true; ctaText(cta, QA_EN ? 'Combination not available' : 'Kombination nicht verfügbar'); }
  }

  // CTA-Text in beide Roll-Ebenen schreiben (Hover-Animation wie Homepage)
  function ctaText(cta, t) {
    var rolls = cta.querySelectorAll('.blc-roll-a, .blc-roll-b');
    if (rolls.length) rolls.forEach(function (s) { s.textContent = t; });
    else cta.textContent = t;
  }

  // ---------- Cart ----------
  function addToCart(id, tag) {
    var body = 'id=' + encodeURIComponent(id) + '&quantity=1';
    if (tag) body += '&properties[_bl_upsell]=' + encodeURIComponent(tag); // Upsell-Tracking
    return fetch(ADD_URL + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      // Set-Completion via Sheet fügt ein Bundle hinzu -> line-item-Tag stirbt bei der Zerlegung.
      // Zusätzlich order-level Cart-Attribut schreiben (überlebt), damit der Kauf attribuierbar bleibt.
      .then(function (res) {
        if (tag && window.blSetOrderAttr) { var _tp = tag.split(':'); return window.blSetOrderAttr(_tp[0], _tp[1] || '').then(function () { return res; }); }
        return res;
      }).then(refreshCart);
  }
  function refreshCart() {
    return fetch('?section_id=cart-helper').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var f = document.getElementById('AjaxCartForm'), nf = doc.getElementById('AjaxCartForm');
      if (f && nf) { f.innerHTML = nf.innerHTML; if (f.ajaxifyCartItems) f.ajaxifyCartItems(); }
      var s = document.getElementById('AjaxCartSubtotal'), ns = doc.getElementById('AjaxCartSubtotal');
      if (s && ns) s.innerHTML = ns.innerHTML;
      var cc = document.querySelector('[data-header-cart-count]'), nc = doc.querySelector('#AjaxCartForm [data-cart-count]');
      if (cc && nc) cc.textContent = nc.textContent;
      var sp = document.querySelector('cart-shipping-progress'); if (sp && sp.updateShippingProgress) sp.updateShippingProgress();
      // Drawer aus dem Leer-Zustand holen: sonst bleibt die "ANYTHING BUTT"-Kachel sichtbar
      // und die echten Produktvorschläge (#cart-recommendations) sind display:none.
      var drawer = document.getElementById('site-cart');
      if (drawer && f) drawer.classList.toggle('is-drawer-empty', f.querySelector('.cart-item') === null);
    });
  }
  function openDrawer() {
    var cart = document.getElementById('site-cart');
    if (cart && cart.show) {
      if (window.preloadImages) window.preloadImages(cart);
      cart.show();
      var rec = document.getElementById('cart-recommendations');
      if (rec && rec.generateRecommendations) rec.generateRecommendations();
    } else {
      window.location.href = (routes.cart_url || '/cart');
    }
  }

  // ---------- Klick-Delegation ----------
  var _removeKeys = null; // Set-Vervollständigung: Keys loser Komponenten, die nach dem Add entfernt werden
  var _upsellTag = null;  // Upsell-Tracking (_bl_upsell), wenn das Sheet aus einem Cart-Hero-Upsell geöffnet wurde
  var _upsellDelta = null; // 30.10.2026: Aufpreis der Set-Vervollständigung (Cent) -> Button „Set sichern · +X €“ statt vollem Set-Preis
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-qa-open]');
    if (openBtn) {
      e.preventDefault();
      if (openBtn.getAttribute('aria-busy') === 'true') return;   // 30.10.2026: Doppelklick
      openBtn.setAttribute('aria-busy', 'true');
      _removeKeys = openBtn.dataset.removeKeys || null;
      _upsellTag = openBtn.dataset.upsell || null;
      _upsellDelta = (openBtn.dataset.delta != null && openBtn.dataset.delta !== '') ? parseInt(openBtn.dataset.delta, 10) : null;
      var handle = openBtn.dataset.handle, raters = openBtn.dataset.raters;
      openBtn.classList.add('is-loading');
      // Korb frisch laden (für Vorbefüllung), dann Produkt + Sheet rendern
      // Korb in der Seitensprache laden: Vorbefuellung vergleicht Korb-Titel/-Werte mit dem (lokalisierten) Produkt-JSON
      fetch(LOC_ROOT.replace(/\/$/, '') + '/cart.js').then(function (r) { return r.json(); }).catch(function () { return null; }).then(function (c) {
        window.__blCartCache = c;
        var show = function (p) { openBtn.classList.remove('is-loading'); openBtn.removeAttribute('aria-busy'); render(p, raters);
          if (_upsellTag && window.blUpsellTrack) { var _tq = _upsellTag.split(':'); window.blUpsellTrack('bl_qa_open', _tq[0], _tq[1] || '', null); } };
        if (cache[handle]) { show(cache[handle]); return; }
        fetch(productUrl(handle)).then(function (r) { return r.json(); }).then(function (p) { return handle === NS_HANDLE ? buildNS(p) : p; }).then(function (p) { if (handle === 'wasserschlauch-new-standard' && p && p.variants) { p.variants = p.variants.filter(function (v) { return String(v.option1) !== '100 cm' && String(v.title).indexOf('100 cm') === -1; }); } cache[handle] = p; show(p); })
          .catch(function () { openBtn.classList.remove('is-loading'); openBtn.removeAttribute('aria-busy'); if (!openBtn.hasAttribute('data-no-nav')) window.location.href = LOC_ROOT.replace(/\/$/, '') + '/products/' + handle; });
      });
      return;
    }
    var dBtn = e.target.closest('[data-qa-direct]');
    if (dBtn) {
      e.preventDefault();
      if (dBtn.classList.contains('is-loading')) return;
      dBtn.classList.add('is-loading');
      addToCart(dBtn.dataset.vid).then(function () { dBtn.classList.remove('is-loading'); openDrawer(); })
        .catch(function () { dBtn.classList.remove('is-loading'); window.location.href = dBtn.dataset.url || '/cart'; });
      return;
    }
  });

  // Bei Resize: offenes Panel an neues Layout anpassen
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      if (!panel) return;
      var wantModal = isDesktop();
      if (panel.classList.contains('qa--modal') !== wantModal) {
        // Neu rendern im passenden Layout (Panel merkt sich Produkt über data)
      }
    }, 200);
  });
})();
